import { useMediaQuery, useTheme } from '@mui/material'
import { useSetAtom } from 'jotai'
import { useEffect } from 'react'

import { isMobileAtom } from '../../contexts/AtomUtil'

function MediaQueryBridge() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const setIsMobile = useSetAtom(isMobileAtom)

  useEffect(() => {
    setIsMobile(isMobile)
  }, [isMobile, setIsMobile])

  return null
}

export default MediaQueryBridge
